import React from 'react'
import PropTypes from 'prop-types'
import './manager-select.scss'

ManagerSelect.propTypes = {
  autoName: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  value: PropTypes.string.isRequired,
}

ManagerSelect.defaultProps = {
  disabled: false,
  label: null,
}

export function ManagerSelect({ autoName, disabled, label, onChange, options, value }) {
  // Find the currently selected option to display its label
  const selectedOption = options.find(opt => opt.value === value)
  const displayLabel = selectedOption ? selectedOption.label : ''

  const handleOptionClick = (optionValue) => {
    // Create a synthetic event to match the expected onChange signature
    const syntheticEvent = {
      target: { value: optionValue }
    }
    onChange(syntheticEvent)
  }

  const containerClass = disabled ? 'manager-select manager-select--disabled' : 'manager-select'
  
  // Heights for positioning (including borders and padding)
  const selectorHeight = 41 // 10px top + 10px bottom padding + 2px borders + line-height
  const optionHeight = 29 // 6px top + 6px bottom padding + 2px borders + line-height

  const vDom =
    <div className={containerClass} data-qa-hook={autoName}>
      <button className="manager-select__selector" disabled={disabled}>
        {label && <span className="manager-select__label">{label} </span>}
        {displayLabel}
        <i className="chevron-xtrasmall" />
      </button>
      {options.map((option, index) => (
        <button
          key={option.value}
          className="manager-select__option"
          onClick={() => handleOptionClick(option.value)}
          disabled={disabled}
          style={{ top: `${selectorHeight + (optionHeight * index)}px` }}
        >
          {option.label}
        </button>
      ))}
    </div>
  return vDom
}